module.exports = __webpack_public_path__ + "img/tx-dm0max-white.0bc5aef0.png";